<div class="p-4" [id]="id() | appendTestId: 'calendar-content'">
  <div
    class="pb-3 font-semibold"
    [id]="id() | appendTestId: 'calendar-label'"
    [attr.data-testid]="id() | appendTestId: 'calendar-label'">
    {{ calendarLabel() }}
  </div>
  <div class="rounded-input size-fit w-full bg-gray-400/10 p-2">
    <aw-month-picker
      [id]="id()"
      [date]="innerDate"
      [shownMonth]="shownMonth()"
      [shownYear]="shownYear()"
      (onMonthChange)="shownMonth.set($event)"
      (onYearChange)="shownYear.set($event)"
      [min]="min()"
      [max]="max()"
      [restrictedDateList]="restrictedDateList()"></aw-month-picker>
    <aw-day-picker
      [id]="id()"
      [date]="innerDate"
      [min]="min()"
      [max]="max()"
      [shownMonth]="shownMonth()"
      [shownYear]="shownYear()"
      (onDayChange)="setDate($event)"
      [restrictedDateList]="restrictedDateList()"></aw-day-picker>
  </div>
  <div [id]="id() | appendTestId: 'calendar-details'">
    @if (showTimePicker()) {
      <aw-time-picker
        [id]="id()"
        [date]="innerDate"
        [label]="
          textStore.texts()
            | filterTexts: ERelationType.timeFrom : EEntityType.generic
            | language
        "
        (onMinuteChange)="setMinutes($event)"
        (onHourChange)="setHours($event)"></aw-time-picker>
    }
    <ng-content></ng-content>
    <div class="flex w-full flex-col gap-4 pt-6">
      <aw-button
        [id]="id() | appendTestId: 'confirm'"
        type="button"
        style="primary"
        (click)="confirm()"
        >{{
          textStore.texts() | filterTexts: ERelationType.save | language
        }}</aw-button
      >
      <aw-button
        [id]="id() | appendTestId: 'cancel-calendar'"
        type="button"
        (click)="onCloseCalendar.emit(true)"
        [style]="'primary-alt'"
        >{{
          textStore.texts() | filterTexts: ERelationType.cancel | language
        }}</aw-button
      >
    </div>
  </div>
</div>
